export const BANNER_SESSION_STORAGE_PREFIX = 'banner-'
